import { Column, CreateDateColumn, Entity, JoinColumn, ManyToMany, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { AssetAssignment } from "./asset-assignment.entity";

@Entity('asset_assignment_transactions') 
export class AssetAssignmentTransaction {

    @PrimaryGeneratedColumn('increment',{
        name: 'asset_assignment_transaction_id'
    })
    assetAssignmentTransactionId: number;

    @Column('int', {
        name:'asset_location_id'
    })
    assetLocationId : number;

    @Column('int',{
        name: 'asset_id'
    })
    assetsId : number;

    @Column('int', {
        name:'employee_id'
    })
    employeeId: number;

    @Column({
        name: 'check_in',
        type: 'datetime'
    })
    checkIn: Date;

    @Column({
        name: 'check_out',
        type: 'datetime'
    })
    checkOut: Date;

    @Column({
        name: 'checkin_reason',
        type: 'varchar'
    })
    checkinReason: string;

    @Column({
        name: 'checkout_reason',
        type: 'varchar'
    })
    checkOutReason: string;

    @Column("boolean", {
        name: 'is_active',
        default: true
    })
    isActive : boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column('varchar',{
        name:'status'
    })
    status : string;

    @ManyToOne(() => AssetAssignment, (assetAssignment) => assetAssignment.assetAssignmentTransaction,{cascade:true})
    @JoinColumn({name: 'asset_assignment_id'})
    assetAssignment: AssetAssignment;
}